import { LinearProgress } from "@material-ui/core";
import {
  StyleRulesCallback,
  WithStyles,
  withStyles
} from "@material-ui/core/styles";
import * as React from "react";
import * as Loadable from "react-loadable";

import RavenService from "../../services/Logging/RavenService";

const styles: StyleRulesCallback = ({}) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  progress: {
    alignSelf: "stretch",
    height: 5
  },
  error: {
    marginTop: 80,
    fontSize: 24,
    textAlign: "center"
  }
});

const InitialLoadingScreenComponent: React.SFC<
  Partial<Loadable.LoadingComponentProps> & Partial<WithStyles<any>>
> = props => {
  const { classes, isLoading, error, pastDelay } = props;
  if (isLoading && pastDelay) {
    return (
      <div className={classes!.container}>
        <LinearProgress className={classes!.progress} />
      </div>
    );
  } else if (error) {
    logError(error);

    return (
      <div className={classes!.container}>
        <div className={classes!.error}>{renderError()}</div>
      </div>
    );
  } else {
    return null;
  }
};

const renderError = () => {
    return (
      <>
        Whoops, looks like something went wrong.
        <br />
        Please try refreshing the page, or contact support@salaryo.com
        <br /> if the issue is not resolved.
      </>
    );
};

const logError = (error: any) => {
  const errorMsg = `Failed importing splitted code ${error}`;
  RavenService.captureMessage(errorMsg);
  console.error(errorMsg);
};

InitialLoadingScreenComponent.defaultProps = {
  isLoading: true,
  pastDelay: true
};

const StyledInitialLoadingScreen = (withStyles(styles) as any)(
  InitialLoadingScreenComponent
);

export const InitialLoadingScreen = (
  props: Partial<Loadable.LoadingComponentProps>
) => <StyledInitialLoadingScreen {...props} />;



// WEBPACK FOOTER //
// ./src/scenes/Navigation/InitialLoadingScreen.tsx